export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// FORK_PATCH_BEGIN: conversation-visibility — feature #7 three-tier visibility.
// Neutral oversight permission granted to "Agent supervisors" by the backend
// (AccountUser#permissions). Mirrors custom/.../conversation_visibility.rb.
export const SUPERVISOR_OVERSIGHT_PERMISSION = 'conversation_inbox_oversight';
// FORK_PATCH_END: conversation-visibility

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    // FORK_PATCH_BEGIN: conversation-visibility — drop plain 'agent' (was ...ROLES)
    // so a normal agent can't see the unassigned tab; admins + supervisors keep it.
    permissions: [
      'administrator',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      SUPERVISOR_OVERSIGHT_PERMISSION,
    ],
    // FORK_PATCH_END: conversation-visibility
  },
  all: {
    count: 'allCount',
    // FORK_PATCH_BEGIN: conversation-visibility — drop plain 'agent' (was ...ROLES)
    // so a normal agent can't see the all tab; admins + supervisors keep it.
    permissions: [
      'administrator',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      SUPERVISOR_OVERSIGHT_PERMISSION,
    ],
    // FORK_PATCH_END: conversation-visibility
  },
};
